import { EmailClient } from "@azure/communication-email";

const connectionString = `endpoint=https://kursusadmemailprovider.europe.communication.azure.com/;accesskey=j3kQQecsJzdRnCw7jLz0TxkspX3Sx/Xu9b4ijFHHM7lwun03knlnyFd3HB7sEgXNmcwbqfdrLO0wWtJ3GfbLLw==`;
export const mailClient = new EmailClient(connectionString);